module.exports = __webpack_public_path__ + "resources/5a2a45c1453284a460573761cf1fbe0d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundsupermove8.png
// module id = 202
// module chunks = 0